// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/app.css";
import "./assets/css/main.css";

import "animate.css";
import axios from "axios";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
import Paused from "./components/Paused.vue";
import locale from "element-ui/lib/locale/lang/tr-TR";

Vue.component("paused", Paused);

Vue.use(ElementUI, {
  locale
});
Vue.use(VueToast, {
  position: "top-left",
  duration: 3000
});

import * as Sentry from "@sentry/vue";
import {
  Integrations
} from "@sentry/tracing";

/*
Sentry.init({
  Vue,
  dsn:
    "https://fce6c6ac9f8d43e5bcbab697524ff988@o1004672.ingest.sentry.io/5965675",
  integrations:
    process.env.NODE_ENV ===
    "production"[
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: ["localhost", "360hizliokuma.com", /^\//],
        logErrors: true
      })
    ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0
});
*/

import slugify from "slugify";

import VuePageTransition from "vue-page-transition";
import _ from "lodash";

Vue.use(VuePageTransition);

Vue.config.productionTip = false;

Vue.prototype.$slugify = text => {
  return slugify(text, {
    locale: "tr",
    replacement: "",
    remove: /[^a-zA-Z0-9- ]/g
  }).toLowerCase();
};

import Vuex from "vuex";
import VueTour from "vue-tour";

require("vue-tour/dist/vue-tour.css");

Vue.use(VueTour);
Vue.use(Vuex);
import VueI18n from "vue-i18n";

import tr from "./languages/tr";
import en from "./languages/en";
import ru from "./languages/ru";
import az from "./languages/az";

Vue.use(VueI18n);

var language;

if (
  window.location.hostname == "app.360hizliokuma.com" ||
  window.location.hostname == "localhost"
) {
  language = "tr";
}

if (window.location.hostname == "en.360hizliokuma.com") {
  language = "en";
}

if (window.location.hostname == "az.360hizliokuma.com") {
  language = "az";
}

if (window.location.hostname == "ru.360hizliokuma.com") {
  language = "ru";
}




const i18n = new VueI18n({
  locale: language,
  messages: {
    tr,
    en,
    ru,
    az
  }
});

import moment from "moment";
axios.defaults.baseURL = "https://api.360hizliokuma.com/";
//axios.defaults.baseURL = "http://localhost:1555/";

window.appVersion = "2";

const store = new Vuex.Store({
  state: {
    user: null,
    token: localStorage.getItem("token"),
    tests: [],
    darkmode: localStorage.getItem("darkmode") !== null ? true : false,
    selectedTick2: localStorage.getItem("tick2") || "Ses1",
    ticks: {
      Ses1: new Audio("/static/tick.mp3"),
      sessiz: new Audio("/static/silence.mp3")
    },
    courses: [],
    correct: new Audio("/static/correct.mp3"),
    incorrect: new Audio("/static/incorrect.mp3"),
    modules: [],
    scale: 1,
    categories: [],
    test_required_popup: false
  }
});

router.beforeEach(async (to, from, next) => {
  if (to.name !== "Login") {
    if (store.state.user == null && store.state.token != null) {
      axios.defaults.headers.common["authorization"] = store.state.token;

      try {
        const res = await axios.get("account/get").catch(err => {
          var date = moment().format("YYYY-MM-DD");
          if (res.data.data.user.status.findIndex(k => k.date == date) == -1) {
            window.vm.$root.$emit("visible");
          }
          return next({
            name: "Login"
          });
        });
        store.state.user = res.data.data.user;
        next();
        const res2 = await axios.get("account/getTests");
        store.state.tests = res2.data.data;
        return;
      } catch (error) {
        console.log(error);
        return next({
          name: "Login"
        });
      }
    }
    if (store.state.user == null && store.state.token == null) {
      return next({
        name: "Login"
      });
    }
    return next();
  } else next();
});

axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response.status === 401) {
      router.push({
        name: "Login"
      });
    }
    return Promise.reject(error);
  }
);

window.vm = new Vue({
  el: "#app",
  router,
  components: {
    App
  },
  template: "<App/>",
  store,
  i18n
});

Vue.prototype.$prepareCourses = function (data) {
  var x = data.map(k => {
    var days = [];

    for (let day = 1; day < k.total_step + 1; day++) {
      days.push({
        day,
        steps: _.orderBy(
          k.steps.filter(x => x.step == day),
          ["order_no"],
          ["ASC"]
        )
      });
    }

    return {
      ...k,
      days
    };
  });
  return x;
};

Vue.prototype.$sesli = harf => {
  var sesliharfler = "âîûaeıioöuüAÎÛAEIİOÖUÜ";

  if (sesliharfler.indexOf(harf) > -1) {
    return true;
  } else {
    return false;
  }
};

Vue.prototype.$hecele = s => {
  var ss = "";
  var hece = "";
  var boşluk = " ";
  var renkler = ["red", "blue"];
  var x = renkler.length;
  var sayaç = 0;

  var heceler = [];

  var istisnalar = {
    "dört,": ["dört,"]
  };

  if (istisnalar[s]) return istisnalar[s];

  for (var i = s.length - 1; i >= 0; i--) {
    hece = s[i] + hece;
    if (
      s[i] == "'" &&
      i > 0 &&
      Vue.prototype.$sesli(s[i - 1]) == true &&
      hece.length > 2
    ) {
      ss =
        "<span style='color:" +
        renkler[sayaç % x] +
        "'>" +
        hece +
        "</span>" +
        ss;
      heceler.push(hece);
      hece = "";
      sayaç++;
    } else if (
      s[i] == "'" &&
      i > 1 &&
      Vue.prototype.$sesli(s[i - 1]) == false &&
      Vue.prototype.$sesli(s[i + 1]) == true
    ) {
      ss =
        "<span style='color:" +
        renkler[sayaç % x] +
        "'>" +
        s[i - 1] +
        hece +
        "</span>" +
        ss;
      heceler.push(hece);
      hece = "";
      sayaç++;
      i--;
    } else {
      if (i == 0) {
        ss =
          "<span style='color:" +
          renkler[sayaç % x] +
          "'>" +
          hece +
          "</span>" +
          ss;
        heceler.push(hece);
        hece = "";
        sayaç++;
      } else {
        if (hece.length == 1) {
          if (
            i > 0 &&
            Vue.prototype.$sesli(s[i]) == true &&
            Vue.prototype.$sesli(s[i - 1]) == true
          ) {
            ss =
              "<span style='color:" +
              renkler[sayaç % x] +
              "'>" +
              hece +
              "</span>" +
              ss;
            heceler.push(hece);
            hece = "";
            sayaç++;
          }
        }

        if (hece.length == 2) {
          if (
            hece[0] == "r" &&
            s[i - 1] == "t" &&
            Vue.prototype.$sesli(s[i - 2]) == false
          ) {} else {
            if (i > 1 && s[i - 1] != "'") {
              if (
                Vue.prototype.$sesli(s[i]) == false &&
                Vue.prototype.$sesli(s[i + 1]) == true
              ) {
                ss =
                  "<span style='color:" +
                  renkler[sayaç % x] +
                  "'>" +
                  hece +
                  "</span>" +
                  ss;
                heceler.push(hece);
                hece = "";
                sayaç++;
              }
              if (
                Vue.prototype.$sesli(s[i]) == true &&
                Vue.prototype.$sesli(s[i - 1]) == true
              ) {
                ss =
                  "<span style='color:" +
                  renkler[sayaç % x] +
                  "'>" +
                  hece +
                  "</span>" +
                  ss;
                heceler.push(hece);
                hece = "";
                sayaç++;
              }
            } else if (
              Vue.prototype.$sesli(s[i]) == false &&
              Vue.prototype.$sesli(s[i - 1]) == true &&
              Vue.prototype.$sesli(s[i + 1]) == true
            ) {
              ss =
                "<span style='color:" +
                renkler[sayaç % x] +
                "'>" +
                hece +
                "</span>" +
                ss;
              heceler.push(hece);
              hece = "";
              sayaç++;
            }
          }
        }

        if (hece.length == 3) {
          if (i > 1) {
            if (
              hece[0] == "r" &&
              s[i - 1] == "t" &&
              Vue.prototype.$sesli(s[i - 2]) == false
            ) {} else {
              if (Vue.prototype.$sesli(s[i]) == false && s[i - 1] != "'") {
                ss =
                  "<span style='color:" +
                  renkler[sayaç % x] +
                  "'>" +
                  hece +
                  "</span>" +
                  ss;
                heceler.push(hece);
                hece = "";
                sayaç++;
              }
            }
          } else if (
            Vue.prototype.$sesli(s[i]) == false &&
            Vue.prototype.$sesli(s[i - 1]) == true
          ) {
            ss =
              "<span style='color:" +
              renkler[sayaç % x] +
              "'>" +
              hece +
              "</span>" +
              ss;
            heceler.push(hece);
            hece = "";
            sayaç++;
          }
        }

        if (hece.length == 4) {
          ss =
            "<span style='color:" +
            renkler[sayaç % x] +
            "'>" +
            hece +
            "</span>" +
            ss;
          heceler.push(hece);
          hece = "";
          sayaç++;
        }
      }
    }
  }

  return heceler.reverse();
};



// WEBPACK FOOTER //
// ./src/main.js